export default "__VITE_ASSET__CI16hujj__";